<template>
  <div class="content">
    <div class="content__title content__title--party content__title--start">
      <router-link
        :to="{ name: 'journal-moving-list' }"
        class="button button--light button--no-indent button--small"
      >
        <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.70917 13.7082C7.61629 13.8013 7.50595 13.8752 7.38447 13.9256C7.263 13.976 7.13277 14.002 7.00125 14.002C6.86973 14.002 6.7395 13.976 6.61802 13.9256C6.49655 13.8752 6.38621 13.8013 6.29332 13.7082L0.293962 7.70884C0.200846 7.61595 0.126968 7.50562 0.0765611 7.38414C0.0261537 7.26266 0.000206594 7.13243 0.000206606 7.00091C0.000206617 6.86939 0.0261537 6.73916 0.0765611 6.61769C0.126969 6.49621 0.200846 6.38587 0.293962 6.29299L6.29333 0.293626C6.48108 0.105873 6.73573 0.00039471 7.00125 0.000394734C7.26677 0.000394757 7.52142 0.105873 7.70918 0.293626C7.89693 0.481379 8.00241 0.736028 8.00241 1.00155C8.00241 1.26707 7.89693 1.52172 7.70917 1.70948L2.41574 7.00091L7.70917 12.2923C7.80229 12.3852 7.87617 12.4956 7.92658 12.617C7.97698 12.7385 8.00293 12.8688 8.00293 13.0003C8.00293 13.1318 7.97698 13.262 7.92658 13.3835C7.87617 13.505 7.80229 13.6153 7.70917 13.7082Z" fill="#2B93E7"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M16 7.00108C16 7.26627 15.8947 7.5206 15.7071 7.70811C15.5196 7.89563 15.2653 8.00098 15.0001 8.00098L2.00149 8.00098C1.7363 8.00098 1.48197 7.89563 1.29445 7.70811C1.10694 7.5206 1.00159 7.26627 1.00159 7.00108C1.00159 6.73589 1.10694 6.48156 1.29445 6.29405C1.48197 6.10653 1.7363 6.00119 2.00149 6.00119L15.0001 6.00119C15.2653 6.00119 15.5196 6.10653 15.7071 6.29405C15.8947 6.48157 16 6.73589 16 7.00108Z" fill="#2B93E7"/>
        </svg>
      </router-link>
      <h1 class="title title--big title--theme">Создание заявки на массовое перемещение</h1>
    </div>

    <form class="form" @submit.prevent="onCheckForm">
      <div class="form__content">
        <!-- Левая часть -->
        <div class="form__part">
          <!-- Переключатель -->
          <div v-if="userRole === 'admin'" class="form-group form-group--switch">
            <div class="switch">
              <input
                type="checkbox"
                id="transferAllSwitch"
                v-model="transferAllFromOrg"
                class="switch__input"
              />
              <label for="transferAllSwitch" class="switch__label">
                <span class="switch__slider"></span>
                <span class="switch__text">Переместить всех участников из организации</span>
              </label>
            </div>
            <div class="form-group__hint">
              Будут перемещены все активные участники из указанной организации.
            </div>
          </div>

          <!-- Номера -->
          <div v-if="!transferAllFromOrg" class="form-group">
            <label for="numbers">Номера билетов<sup>*</sup></label>
            <div class="form-control" :class="{ 'form-control--error': $v.form.numbers.$error }">
              <textarea
                id="numbers"
                class="form-control__input"
                v-model="form.numbers"
                rows="6"
                placeholder="Введите номера членских билетов, по одному на строку или через запятую"
              ></textarea>
            </div>
            <div class="form-group__hint">
              Пример: 1001, 1002, 1003
            </div>
            <div class="form-group__error" v-if="$v.form.numbers.$dirty && !$v.form.numbers.required">
              Обязательное поле
            </div>
            <div class="form-group__error" v-else-if="$v.form.numbers.$dirty && !validNumbers">
              Некорректные номера. Только положительные целые числа.
            </div>
          </div>

          <!-- Организация-источник -->
          <div v-if="transferAllFromOrg && userRole === 'admin'" class="form-group">
            <label>Региональная организация — источник<sup>*</sup></label>
            <v-select
              v-model="form.from_region_org"
              :reduce="item => item.id"
              :filterable="false"
              :clearable="false"
              :options="fromRegionOptions"
              label="name"
              :get-option-label="getLabel"
              placeholder="Выберите рег. организацию-источник"
              class="select"
              :class="{ 'select--error': $v.form.from_region_org.$error }"
              @search="onFromRegionSearch"
            >
              <template slot="open-indicator">
                <svg class="select__open-indicator" xmlns="http://www.w3.org/2000/svg" width="23" height="23" fill="none">
                  <path clip-rule="evenodd" d="M10.06 17.25a7.19 7.19 0 100-14.38 7.19 7.19 0 000 14.38z" stroke="#C7CFDD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M20.12 20.12l-4.98-4.98" stroke="#C7CFDD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </template>
              <template slot="no-options">Введите запрос для поиска</template>
              <template slot="option" slot-scope="option">
                <div class="select__item d-center" v-if="option">
                  {{ option.name }} (ID: {{ option.id }})
                </div>
              </template>
              <template slot="selected-option" slot-scope="option">
                <div class="selected d-center" v-if="option">
                  {{ option.name }} (ID: {{ option.id }})
                </div>
              </template>
            </v-select>
            <div class="form-group__error" v-if="$v.form.from_region_org.$dirty && !$v.form.from_region_org.required">
              Обязательное поле
            </div>
          </div>

          <!-- Скан -->
          <div class="form-group" :class="{ 'form-group--error': $v.form.file.$error }">
            <label>Скан-копия заявления<sup v-if="userRegion && form.region_org && userRegion !== form.region_org">*</sup></label>
            <Uploader :getFileHash="getFileHash" limit-files="1" :fileUrl="file_url" @remove-file="onRemoveFile" />
            <div class="form-group__hint" v-if="userRegion && form.region_org && userRegion === form.region_org">
              При перемещении внутри одной региональной организации скан не требуется.
            </div>
            <div class="form-group__error" v-if="$v.form.file.$dirty && !$v.form.file.required">
              Обязательное поле
            </div>
          </div>
        </div>

        <!-- Правая часть: назначение -->
        <div class="form__part">
          <div v-if="userRole === 'admin'" class="form-group">
            <label>Региональная организация — назначение<sup>*</sup></label>
            <v-select
              v-model="form.region_org"
              :reduce="item => item.id"
              :filterable="false"
              :clearable="false"
              :options="region_options"
              label="name"
              :get-option-label="getLabel"
              placeholder="Выберите рег. организацию назначения"
              class="select"
              :class="{ 'select--error': $v.form.region_org.$error }"
              @search="onRegionSearch"
            >
              <template slot="open-indicator">
                <svg class="select__open-indicator" xmlns="http://www.w3.org/2000/svg" width="23" height="23" fill="none">
                  <path clip-rule="evenodd" d="M10.06 17.25a7.19 7.19 0 100-14.38 7.19 7.19 0 000 14.38z" stroke="#C7CFDD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M20.12 20.12l-4.98-4.98" stroke="#C7CFDD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </template>
              <template slot="no-options">Введите запрос для поиска</template>
              <template slot="option" slot-scope="option">
                <div class="select__item d-center" v-if="option">
                  {{ option.name }} (ID: {{ option.id }})
                </div>
              </template>
              <template slot="selected-option" slot-scope="option">
                <div class="selected d-center" v-if="option">
                  {{ option.name }} (ID: {{ option.id }})
                </div>
              </template>
            </v-select>
          </div>
        </div>
      </div>

      <div class="holder holder--end">
        <button
          class="button"
          type="submit"
          :class="{ 'preload': loading }"
          :disabled="$v.form.$error || (!transferAllFromOrg && !validNumbers)"
        >
          <span>Создать заявку</span>
          <img src="@/assets/img/preloader.svg" alt="" class="button__preloader"/>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'
import Uploader from '@/components/Uploader'

export default {
  name: 'BulkMovingCreate',
  mixins: [validationMixin],
  components: { Uploader },
  validations() {
    return {
      form: {
        numbers: {
          required: requiredIf(() => !this.transferAllFromOrg)
        },
        from_region_org: {
          required: requiredIf(() => this.transferAllFromOrg && this.userRole === 'admin')
        },
        region_org: { required },
        file: {
          required() {
            return this.userRegion && this.form.region_org && this.userRegion !== this.form.region_org
              ? !!this.form.file
              : true
          }
        }
      }
    }
  },
  data() {
    return {
      transferAllFromOrg: false,
      form: {
        numbers: '',
        file: '',
        from_region_org: null,
        region_org: null,
      },
      file_url: `${process.env.VUE_APP_API_URL}files/`,
      loading: false,
      region_options: [],
      fromRegionOptions: [],
    }
  },
  computed: {
    userRegion() {
      return this.$store.state.organization
    },
    userRole() {
      return this.$store.state.userRole
    },
    validNumbers() {
      if (!this.form.numbers) return false
      const nums = this.parseNumbers(this.form.numbers)
      return nums.length > 0 && nums.every(n => Number.isInteger(n) && n > 0)
    },
  },
  mounted() {
    if (this.userRegion && this.userRole !== 'admin') {
      this.form.region_org = this.userRegion
    }
  },
  methods: {
    parseNumbers(input) {
      return input
        .split(/[\s,;\n]+/)
        .map(s => s.trim())
        .filter(s => s !== '')
        .map(s => parseInt(s, 10))
        .filter(n => !isNaN(n))
    },

    onCheckForm() {
      this.$v.form.$touch()
      const isValid = this.transferAllFromOrg
        ? !!this.form.from_region_org
        : this.validNumbers

      if (this.$v.form.$invalid || !isValid) {
        this.$notify({ type: 'warn', title: 'Внимание!', text: 'Проверьте правильность заполнения полей формы.' })
        return
      }
      this.sendForm()
    },

    sendForm() {
  this.loading = true

  const payload = {
    region_org: this.form.region_org // ← обязательно
  }

  // Скан, если есть
  if (this.form.file) {
    payload.file = this.form.file
  }

  if (this.transferAllFromOrg && this.userRole === 'admin') {
    // Массовое: отправляем from_region_org как ID
    payload.from_region_org = this.form.from_region_org
    // journal_numbers не отправляем
  } else {
    // По номерам
    payload.journal_numbers = this.parseNumbers(this.form.numbers)
    // from_region_org не отправляем
  }

  this.$store.dispatch('journal/POST_BULK_MOVING_DATA', payload)
    .then(() => {
      this.loading = false
      this.$router.push({ name: 'journal-moving-list' })
      this.$notify({ type: 'success', title: 'Успех!', text: 'Заявка создана.' })
    })
    .catch(error => {
      this.loading = false
      const msg = error.response?.data?.non_field_errors?.[0] || 'Ошибка при создании заявки'
      this.$notify({ type: 'error', title: 'Ошибка!', text: msg })
    })
},

    getLabel(option) {
      if (typeof option === 'object' && option !== null) {
        return option[this.label] || ''
      }
      return option || ''
    },

    onRegionSearch: debounce(function(search, loading) {
      loading(true)
      this.$store.dispatch('regOrg/GET_QUERY', search)
        .then(response => {
          this.region_options = Array.isArray(response.data) ? response.data : []
          loading(false)
        })
        .catch(() => {
          this.region_options = []
          loading(false)
        })
    }, 350),

    onFromRegionSearch: debounce(function(search, loading) {
      loading(true)
      this.$store.dispatch('regOrg/GET_QUERY', search)
        .then(response => {
          this.fromRegionOptions = Array.isArray(response.data) ? response.data : []
          loading(false)
        })
        .catch(() => {
          this.fromRegionOptions = []
          loading(false)
        })
    }, 350),

    getFileHash(value) {
      this.form.file = value
      this.$v.form.file.$touch()
    },
    onRemoveFile() {
      this.form.file = ''
      this.$v.form.file.$touch()
    },
  }
}
</script>

<style scoped>
.form-group--switch {
  margin-bottom: 24px;
}

/* Toggle switch */
.switch {
  display: flex;
  align-items: center;
  gap: 12px;
}

.switch__input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.switch__label {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  gap: 10px;
}

.switch__slider {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
  background-color: #ccc;
  border-radius: 10px;
  transition: background-color 0.2s;
}

.switch__slider::before {
  content: '';
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: white;
  top: 2px;
  left: 2px;
  transition: transform 0.2s;
}

.switch__input:checked + .switch__label .switch__slider {
  background-color: #2b93e7;
}

.switch__input:checked + .switch__label .switch__slider::before {
  transform: translateX(20px);
}

.switch__text {
  font-size: 14px;
  color: #333;
}
</style>